(function () {
  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function safeRun(label, fn) {
    try {
      fn();
    } catch (error) {
      if (window.console && console.warn) {
        console.warn('[Smart PDP] ' + label + ' skipped:', error);
      }
    }
  }

  function initTrustCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-smart-pdp-open]');
    if (!cards.length) return;

    var modal = document.querySelector('[data-smart-pdp-modal]');
    var modalTitle = modal && modal.querySelector('[data-smart-pdp-modal-title]');
    var modalContent = modal && modal.querySelector('[data-smart-pdp-modal-content]');

    function getContentFromCard(card) {
      var templateId = card.getAttribute('data-smart-pdp-template');
      var template = templateId ? document.getElementById(templateId) : null;

      if (template) return template.innerHTML || '';
      return card.getAttribute('data-smart-pdp-content') || '';
    }

    function setContent(title, html) {
      if (modalTitle) modalTitle.textContent = title || '';
      if (modalContent) modalContent.innerHTML = html || '';
    }

    function getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }

    function lockBodyScroll() {
      if (isDesignMode()) return;
      var width = getScrollbarWidth();
      if (width > 0) document.body.style.paddingRight = width + 'px';
      document.body.classList.add('smart-pdp-no-scroll');
    }

    function unlockBodyScroll() {
      if (isDesignMode()) return;
      document.body.classList.remove('smart-pdp-no-scroll');
      document.body.style.paddingRight = '';
    }

    function openInfo(title, html) {
      if (!modal) return;
      setContent(title, html);
      lockBodyScroll();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeAll() {
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }

      document.querySelectorAll('[data-smart-pdp-drawer-mask]').forEach(function (drawerMask) {
        drawerMask.classList.remove('is-open');
        drawerMask.setAttribute('aria-hidden', 'true');
      });

      unlockBodyScroll();
    }

    cards.forEach(function (card) {
      if (card.dataset.smartPdpBound === 'true') return;
      card.dataset.smartPdpBound = 'true';
      card.addEventListener('click', function () {
        openInfo(
          card.getAttribute('data-smart-pdp-title'),
          getContentFromCard(card)
        );
      });
    });

    document.querySelectorAll('[data-smart-pdp-close]').forEach(function (btn) {
      if (btn.dataset.smartPdpBound === 'true') return;
      btn.dataset.smartPdpBound = 'true';
      btn.addEventListener('click', closeAll);
    });

    if (!document.documentElement.dataset.smartPdpEscBound) {
      document.documentElement.dataset.smartPdpEscBound = 'true';
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAll();
      });
    }
  }


  function getSmartPdpPreviewQuery() {
    var params = new URLSearchParams(window.location.search);
    var keep = new URLSearchParams();

    ['preview_theme_id', '_ab', '_fd', '_sc', 'pb'].forEach(function (key) {
      if (params.has(key)) keep.set(key, params.get(key));
    });

    var query = keep.toString();
    return query ? '?' + query : '';
  }

  function addSmartPdpPreviewQuery(url) {
    var previewQuery = getSmartPdpPreviewQuery();
    if (!previewQuery || !url || url.indexOf('mailto:') === 0 || url.indexOf('tel:') === 0 || url.indexOf('#') === 0) return url;

    try {
      var absolute = new URL(url, window.location.origin);
      if (absolute.origin !== window.location.origin) return url;

      var previewParams = new URLSearchParams(previewQuery);
      previewParams.forEach(function (value, key) {
        if (!absolute.searchParams.has(key)) absolute.searchParams.set(key, value);
      });

      return absolute.pathname + absolute.search + absolute.hash;
    } catch (error) {
      return url;
    }
  }

  function initSmartPdpPreviewLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-smart-preview-link]').forEach(function (link) {
      var href = link.getAttribute('href');
      var nextHref = addSmartPdpPreviewQuery(href);
      if (nextHref) link.setAttribute('href', nextHref);
    });
  }


  function getLineItemProperties(form) {
    var properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      var match = input.name.match(/^properties\[(.*)\]$/);
      if (match && input.value !== '') properties[match[1]] = input.value;
    });
    return properties;
  }

  function initCustomLogo(root) {
    var scope = root || document;
    var boxes = scope.querySelectorAll('[data-smart-pdp-custom-logo]');
    if (!boxes.length) return;

    boxes.forEach(function (box) {
      var checkbox = box.querySelector('[data-smart-pdp-custom-logo-checkbox]');
      if (!checkbox || box.dataset.smartPdpBound === 'true') return;
      box.dataset.smartPdpBound = 'true';

      var propertyName = box.getAttribute('data-property-name') || 'Custom Logo Service';
      var propertyValue = box.getAttribute('data-property-value') || 'Yes';
      var addonVariantId = box.getAttribute('data-addon-variant-id');
      var addonProductTitle = box.getAttribute('data-addon-product-title') || 'Custom Logo Service';
      var addonQuantityMode = box.getAttribute('data-addon-quantity-mode') || 'per_order';
      var forms = document.querySelectorAll('form[action*="/cart/add"]');

      function updatePropertyInput() {
        if (isDesignMode()) return;
        forms.forEach(function (form) {
          var inputName = 'properties[' + propertyName + ']';
          var input = form.querySelector('input[name="' + inputName.replace(/"/g, '\\"') + '"]');
          if (checkbox.checked) {
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = inputName;
              form.appendChild(input);
            }
            input.value = propertyValue;
          } else if (input) {
            input.remove();
          }
        });
      }

      function bindPaidAddon(form) {
        if (isDesignMode()) return;
        if (!addonVariantId || form.dataset.smartPdpLogoAddonBound === 'true') return;
        form.dataset.smartPdpLogoAddonBound = 'true';

        form.addEventListener('submit', function (event) {
          if (!checkbox.checked) return;

          event.preventDefault();

          var variantInput = form.querySelector('[name="id"]');
          if (!variantInput || !variantInput.value) return;

          var quantityInput = form.querySelector('[name="quantity"]');
          var quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;
          if (!quantity || quantity < 1) quantity = 1;

          var submitButtons = form.querySelectorAll('[type="submit"]');
          submitButtons.forEach(function (btn) {
            btn.disabled = true;
            btn.setAttribute('aria-busy', 'true');
          });

          var properties = getLineItemProperties(form);
          properties[propertyName] = propertyValue;

          var payload = {
            items: [
              {
                id: Number(variantInput.value),
                quantity: quantity,
                properties: properties
              },
              {
                id: Number(addonVariantId),
                quantity: addonQuantityMode === 'match_product_quantity' ? quantity : 1,
                properties: {
                  'Service for': document.title || 'Photo booth product',
                  'Added from': addonProductTitle
                }
              }
            ]
          };

          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Add to cart failed');
              return response.json();
            })
            .then(function () {
              window.location.href = addSmartPdpPreviewQuery((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart');
            })
            .catch(function () {
              submitButtons.forEach(function (btn) {
                btn.disabled = false;
                btn.removeAttribute('aria-busy');
              });
              form.submit();
            });
        });
      }

      checkbox.addEventListener('change', updatePropertyInput);
      updatePropertyInput();
      // Paid logo add-on is handled by Smart Cart Popup and Buy It Now handlers.
      // forms.forEach(bindPaidAddon);
    });
  }


  function getSmartPdpHeaderOffset() {
    if (isDesignMode()) return 0;

    var selectors = [
      '[data-smart-header] .smart-header__bar',
      '[data-smart-header]',
      '#app-header .smart-header__bar',
      '#app-header',
      '.shopify-section-header',
      '.shopify-section-group-header-group',
      'header',
      '.site-header',
      '.header-wrapper',
      '.f\\:header__wrapper'
    ];

    var maxBottom = 0;

    selectors.forEach(function (selector) {
      var elements = [];
      try {
        elements = Array.prototype.slice.call(document.querySelectorAll(selector));
      } catch (error) {
        elements = [];
      }

      elements.forEach(function (el) {
        if (!el || el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return;

        var style = getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return;

        var rect = el.getBoundingClientRect();
        if (!rect || rect.height < 20) return;

        var isAtTop = rect.top <= 6 && rect.bottom > 8;
        var isStickyLike = style.position === 'fixed' || style.position === 'sticky';

        if (isAtTop || isStickyLike) {
          maxBottom = Math.max(maxBottom, Math.round(rect.bottom));
        }
      });
    });

    if (maxBottom < 0) maxBottom = 0;
    if (maxBottom > 180) maxBottom = 180;
    return maxBottom;
  }

  function updateSmartPdpStickyOffsets(root) {
    var scope = root || document;
    var offset = getSmartPdpHeaderOffset();
    scope.querySelectorAll('[data-smart-pdp-tabs]').forEach(function (tabsRoot) {
      tabsRoot.style.setProperty('--smart-pdp-tabs-sticky-top', offset + 'px');
    });
  }

  function initSmartPdpStickyOffset(root) {
    updateSmartPdpStickyOffsets(root);

    if (document.documentElement.dataset.smartPdpStickyOffsetBound === 'true') return;
    document.documentElement.dataset.smartPdpStickyOffsetBound = 'true';

    var ticking = false;
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateSmartPdpStickyOffsets(document);
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  function initMediaThumbs(root) {
    var scope = root || document;
    var groups = scope.querySelectorAll('[data-product-single-media-group]');
    if (!groups.length) return;

    function clamp(number, min, max) {
      return Math.max(min, Math.min(max, number));
    }

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function getProductRoot(group) {
      return group.closest('[data-section-type="product"]') || group.closest('article') || document;
    }

    function getProductSection(group) {
      return group.closest('[id^="shopify-section-"]') || getProductRoot(group);
    }

    function getSectionId(group) {
      var productRoot = getProductRoot(group);
      return productRoot && productRoot.getAttribute ? productRoot.getAttribute('data-section-id') : null;
    }

    function getProductData(group) {
      if (group.__smartPdpProductData !== undefined) return group.__smartPdpProductData;

      var sectionId = getSectionId(group);
      var jsonEl = sectionId ? document.getElementById('ProductJson-' + sectionId) : null;

      if (jsonEl && jsonEl.textContent) {
        try {
          group.__smartPdpProductData = JSON.parse(jsonEl.textContent);
          return group.__smartPdpProductData;
        } catch (error) {
          group.__smartPdpProductData = null;
        }
      }

      if (window.Station && Station.Theme && Station.Theme.current && Station.Theme.current.product) {
        group.__smartPdpProductData = Station.Theme.current.product;
        return group.__smartPdpProductData;
      }

      group.__smartPdpProductData = null;
      return null;
    }

    function getAllSlides(group) {
      return Array.prototype.slice.call(group.querySelectorAll('.smart-pdp-gallery-main .primary-media-types .primary-media-container'));
    }

    function getAllThumbs(group) {
      return Array.prototype.slice.call(group.querySelectorAll('.secondary-media-types .secondary-media-container'));
    }

    function getThumbItem(thumb) {
      return thumb && thumb.closest ? thumb.closest('.item') : null;
    }

    function isGalleryHidden(element) {
      if (!element) return true;
      if (element.hidden || element.getAttribute('data-variant-gallery-hidden') === 'true') return true;
      var item = getThumbItem(element);
      return !!(item && (item.hidden || item.getAttribute('data-variant-gallery-hidden') === 'true'));
    }

    function getMediaOrder(element) {
      var item = getThumbItem(element);
      var value = (item || element).getAttribute('data-media-order');
      var parsed = parseInt(value, 10);
      return isNaN(parsed) ? 0 : parsed;
    }

    function sortGalleryNodes(nodes) {
      return nodes.sort(function (a, b) {
        var aItem = getThumbItem(a);
        var bItem = getThumbItem(b);
        var aCurrent = (aItem || a).getAttribute('data-current-variant-media') === 'true';
        var bCurrent = (bItem || b).getAttribute('data-current-variant-media') === 'true';
        if (aCurrent !== bCurrent) return aCurrent ? -1 : 1;
        return getMediaOrder(a) - getMediaOrder(b);
      });
    }

    function getSlides(group) {
      return sortGalleryNodes(getAllSlides(group).filter(function (slide) {
        return !isGalleryHidden(slide);
      }));
    }

    function getThumbs(group) {
      return sortGalleryNodes(getAllThumbs(group).filter(function (thumb) {
        return !isGalleryHidden(thumb);
      }));
    }

    function getScroller(group) {
      return group.querySelector('.smart-pdp-gallery-main .primary-media-types');
    }

    function getThumbTrack(group) {
      return group.querySelector('.smart-pdp-media-thumbs__track');
    }

    function getMediaId(element) {
      return element && element.getAttribute ? element.getAttribute('data-media-id') : null;
    }

    function getGalleryRole(element) {
      if (!element) return 'shared';
      var item = getThumbItem(element);
      return (item || element).getAttribute('data-gallery-role') || 'shared';
    }

    function buildIndex(group) {
      var mediaIdToIndex = {};
      getSlides(group).forEach(function (slide, index) {
        var mediaId = getMediaId(slide);
        if (mediaId) mediaIdToIndex[String(mediaId)] = index;
      });
      group.__smartPdpMediaIdToIndex = mediaIdToIndex;
      return mediaIdToIndex;
    }

    function getIndexByMediaId(group, mediaId) {
      if (!mediaId) return -1;
      var map = group.__smartPdpMediaIdToIndex || buildIndex(group);
      return Object.prototype.hasOwnProperty.call(map, String(mediaId)) ? map[String(mediaId)] : -1;
    }

    function getSelectedVariant(group) {
      var productRoot = getProductRoot(group);
      var variantInput = productRoot.querySelector('form[action*="/cart/add"] input[name="id"]');
      var variantId = variantInput && variantInput.value;
      var product = getProductData(group);
      var variants = product && product.variants ? product.variants : [];

      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(variantId)) return variants[i];
      }

      return null;
    }

    function getVariantMediaId(variant) {
      if (!variant) return null;
      if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
      if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
      return null;
    }

    function getVariantMediaIndex(group) {
      var variant = getSelectedVariant(group);
      var mediaId = getVariantMediaId(variant);
      return getIndexByMediaId(group, mediaId);
    }

    function getActiveIndex(group) {
      var activeThumb = group.querySelector('.secondary-media-types .secondary-media-container.active');
      var thumbs = getThumbs(group);
      var thumbIndex = activeThumb ? thumbs.indexOf(activeThumb) : -1;
      if (thumbIndex >= 0) return thumbIndex;

      var activeSlide = group.querySelector('.smart-pdp-gallery-main .primary-media-types .primary-media-container.active');
      var slides = getSlides(group);
      var slideIndex = activeSlide ? slides.indexOf(activeSlide) : -1;
      if (slideIndex >= 0) return slideIndex;

      var variantIndex = getVariantMediaIndex(group);
      if (variantIndex >= 0) return variantIndex;

      return 0;
    }

    function getNearestIndexFromScroll(group) {
      var scroller = getScroller(group);
      var slides = getSlides(group);
      if (!scroller || !slides.length) return 0;

      var left = scroller.scrollLeft;
      var bestIndex = 0;
      var bestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var target = slide.offsetLeft - scroller.offsetLeft;
        var distance = Math.abs(target - left);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    }

    function setNodeVisibility(element, visible) {
      if (!element) return;

      element.classList.toggle('is-variant-media-hidden', !visible);
      element.setAttribute('data-variant-gallery-hidden', visible ? 'false' : 'true');

      if (visible) {
        element.removeAttribute('hidden');
        element.setAttribute('aria-hidden', 'false');
        element.style.removeProperty('display');
        element.style.removeProperty('visibility');
        if (element.hasAttribute('tabindex')) element.setAttribute('tabindex', '0');
      } else {
        element.setAttribute('hidden', '');
        element.setAttribute('aria-hidden', 'true');
        if (element.hasAttribute('tabindex')) element.setAttribute('tabindex', '-1');
        element.classList.remove('active');
        var media = element.querySelector && element.querySelector('.primary-media, .secondary-media');
        if (media) media.classList.remove('active');
      }
    }

    function setCurrentMarker(element, isCurrent) {
      if (!element) return;
      element.setAttribute('data-current-variant-media', isCurrent ? 'true' : 'false');
      element.classList.toggle('is-current-variant-media', isCurrent);
      element.style.order = isCurrent ? '-1' : '0';
    }

    function getFallbackMediaId(slides) {
      var shared = slides.find(function (slide) {
        return getGalleryRole(slide) !== 'variant-hero';
      });
      return getMediaId(shared || slides[0]);
    }

    function getInitiallyMarkedMediaId(group) {
      var marked = getAllSlides(group).find(function (slide) {
        return slide.getAttribute('data-current-variant-media') === 'true';
      });
      if (marked) return getMediaId(marked);

      var active = getAllSlides(group).find(function (slide) {
        return slide.classList.contains('active');
      });
      return getMediaId(active || getAllSlides(group)[0]);
    }

    function imageReadyPromise(image) {
      if (!image) return Promise.resolve();
      if (image.decode) {
        return image.decode().catch(function () {
          return null;
        });
      }
      if (image.complete) return Promise.resolve();
      return new Promise(function (resolve) {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    }

    function activateDeferredImage(image, highPriority) {
      if (!image) return Promise.resolve();

      if (highPriority) {
        image.loading = 'eager';
        image.setAttribute('fetchpriority', 'high');
      } else {
        image.setAttribute('fetchpriority', 'auto');
      }

      if (image.dataset.smartVariantActivated === 'true') {
        return imageReadyPromise(image);
      }

      var source = image.getAttribute('data-smart-variant-src');
      var sourceSet = image.getAttribute('data-smart-variant-srcset');
      var sizes = image.getAttribute('data-smart-variant-sizes');
      if (!source && !sourceSet) return imageReadyPromise(image);

      image.dataset.smartVariantActivated = 'true';
      if (sizes) image.setAttribute('sizes', sizes);
      if (sourceSet) image.setAttribute('srcset', sourceSet);
      if (source) image.setAttribute('src', source);
      image.classList.remove('smart-variant-image-deferred');
      return imageReadyPromise(image);
    }

    function activateMedia(group, mediaId) {
      if (!mediaId) return;
      var slide = getAllSlides(group).find(function (candidate) {
        return String(getMediaId(candidate)) === String(mediaId);
      });
      if (!slide) return;

      var primaryImages = Array.prototype.slice.call(slide.querySelectorAll('img[data-smart-variant-src], img[data-smart-variant-activated="true"]'));
      var thumb = getAllThumbs(group).find(function (candidate) {
        return String(getMediaId(candidate)) === String(mediaId);
      });
      var thumbImages = thumb ? Array.prototype.slice.call(thumb.querySelectorAll('img[data-smart-variant-src], img[data-smart-variant-activated="true"]')) : [];
      var hasDeferredPrimary = primaryImages.some(function (image) {
        return image.getAttribute('data-smart-variant-src') && image.dataset.smartVariantActivated !== 'true';
      });

      if (hasDeferredPrimary) slide.classList.add('is-variant-media-loading');

      var promises = primaryImages.map(function (image) {
        return activateDeferredImage(image, true);
      }).concat(thumbImages.map(function (image) {
        return activateDeferredImage(image, false);
      }));

      Promise.all(promises).then(function () {
        slide.classList.remove('is-variant-media-loading');
      }, function () {
        slide.classList.remove('is-variant-media-loading');
      });
    }

    function applyVariantMediaFilter(group, options) {
      var allSlides = getAllSlides(group);
      var allThumbs = getAllThumbs(group);
      if (!allSlides.length) return;

      var variant = getSelectedVariant(group);
      var variantId = variant && variant.id ? String(variant.id) : '';
      var variantMediaId = getVariantMediaId(variant);
      var hasVariantHeroes = allSlides.some(function (slide) {
        return getGalleryRole(slide) === 'variant-hero';
      });
      var variantMediaExists = variantMediaId && allSlides.some(function (slide) {
        return String(getMediaId(slide)) === String(variantMediaId);
      });
      var currentMediaId;

      if (hasVariantHeroes) {
        currentMediaId = variantMediaExists ? variantMediaId : getFallbackMediaId(allSlides);
      } else {
        currentMediaId = variantMediaExists ? variantMediaId : getInitiallyMarkedMediaId(group);
      }
      if (!currentMediaId) currentMediaId = getMediaId(allSlides[0]);

      allSlides.forEach(function (slide) {
        var mediaId = getMediaId(slide);
        var isCurrent = String(mediaId) === String(currentMediaId);
        var visible = !hasVariantHeroes || getGalleryRole(slide) !== 'variant-hero' || isCurrent;
        setCurrentMarker(slide, isCurrent);
        setNodeVisibility(slide, visible);
      });

      allThumbs.forEach(function (thumb) {
        var item = getThumbItem(thumb);
        var mediaId = getMediaId(thumb);
        var isCurrent = String(mediaId) === String(currentMediaId);
        var visible = !hasVariantHeroes || getGalleryRole(thumb) !== 'variant-hero' || isCurrent;

        setCurrentMarker(item, isCurrent);
        setCurrentMarker(thumb, isCurrent);
        setNodeVisibility(item, visible);
        setNodeVisibility(thumb, visible);
      });

      var thumbsWrap = group.querySelector('.secondary-media-types');
      if (thumbsWrap) {
        thumbsWrap.classList.toggle('hidden', getThumbs(group).length <= 1);
      }

      group.dataset.smartPdpActiveVariantId = variantId;
      group.dataset.smartPdpActiveMediaId = currentMediaId || '';
      group.dataset.smartPdpVariantGallery = hasVariantHeroes ? 'filtered' : 'preserved';

      activateMedia(group, currentMediaId);
      buildIndex(group);
      var currentIndex = getIndexByMediaId(group, currentMediaId);
      scrollToIndex(group, currentIndex >= 0 ? currentIndex : 0, options && options.source ? options.source : 'variant', 'auto');
    }

    function updateArrowState(group, index) {
      var slides = getSlides(group);
      var prev = group.querySelector('[data-smart-pdp-gallery-prev]');
      var next = group.querySelector('[data-smart-pdp-gallery-next]');
      var hasMultiple = slides.length > 1;

      if (prev) {
        prev.disabled = !hasMultiple || index <= 0;
        prev.setAttribute('aria-disabled', prev.disabled ? 'true' : 'false');
      }

      if (next) {
        next.disabled = !hasMultiple || index >= slides.length - 1;
        next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
      }
    }

    function keepThumbVisible(group, index, behavior) {
      var thumbs = getThumbs(group);
      var thumb = thumbs[index];
      var track = getThumbTrack(group);
      if (!thumb || !track) return;

      var trackRect = track.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var padding = 10;
      var targetLeft = track.scrollLeft;

      if (thumbRect.left < trackRect.left + padding) {
        targetLeft += thumbRect.left - trackRect.left - padding;
      } else if (thumbRect.right > trackRect.right - padding) {
        targetLeft += thumbRect.right - trackRect.right + padding;
      } else {
        return;
      }

      try {
        track.scrollTo({ left: Math.max(0, targetLeft), behavior: behavior || 'auto' });
      } catch (error) {
        track.scrollLeft = Math.max(0, targetLeft);
      }
    }

    function setActive(group, index, options) {
      var slides = getSlides(group);
      var thumbs = getThumbs(group);
      if (!slides.length) return;

      index = clamp(index, 0, slides.length - 1);
      group.__smartPdpCurrentIndex = index;

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === index;
        slide.classList.toggle('active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        var media = slide.querySelector('.primary-media');
        if (media) media.classList.toggle('active', isActive);
      });

      thumbs.forEach(function (thumb, thumbIndex) {
        var isActive = thumbIndex === index;
        thumb.classList.toggle('active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        var item = getThumbItem(thumb);
        if (item) item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      updateArrowState(group, index);

      if (!options || options.keepThumbVisible !== false) {
        keepThumbVisible(group, index, options && options.thumbBehavior ? options.thumbBehavior : 'auto');
      }
    }

    function scrollToIndex(group, index, source, behavior) {
      var scroller = getScroller(group);
      var slides = getSlides(group);
      if (!scroller || !slides.length) return;

      index = clamp(index, 0, slides.length - 1);
      var target = slides[index].offsetLeft - scroller.offsetLeft;
      var useBehavior = behavior || (source === 'init' || source === 'variant' || source === 'resize' ? 'auto' : 'smooth');

      group.__smartPdpProgrammaticScroll = true;
      setActive(group, index, { thumbBehavior: source === 'arrow' ? 'auto' : 'smooth' });

      try {
        scroller.scrollTo({ left: Math.max(0, target), behavior: useBehavior });
      } catch (error) {
        scroller.scrollLeft = Math.max(0, target);
      }

      window.clearTimeout(group.__smartPdpProgrammaticTimer);
      group.__smartPdpProgrammaticTimer = window.setTimeout(function () {
        group.__smartPdpProgrammaticScroll = false;
        setActive(group, getNearestIndexFromScroll(group), { thumbBehavior: 'auto' });
      }, useBehavior === 'smooth' ? 420 : 60);
    }

    function syncFromNativeScroll(group) {
      if (group.__smartPdpProgrammaticScroll) return;
      setActive(group, getNearestIndexFromScroll(group), { thumbBehavior: 'auto' });
    }

    function scheduleVariantSync(group) {
      function sync(source) {
        applyVariantMediaFilter(group, { source: source || 'variant' });
      }

      window.clearTimeout(group.__smartPdpVariantSyncTimerA);
      window.clearTimeout(group.__smartPdpVariantSyncTimerB);
      window.requestAnimationFrame(function () {
        sync('variant');
      });
      group.__smartPdpVariantSyncTimerA = window.setTimeout(function () {
        sync('variant');
      }, 80);
      group.__smartPdpVariantSyncTimerB = window.setTimeout(function () {
        sync('variant');
      }, 220);
    }

    function prefetchVariantHeroes(group) {
      if (document.hidden) return;
      if (!group.__smartPdpPrefetchImages) group.__smartPdpPrefetchImages = [];

      getAllSlides(group).forEach(function (slide) {
        if (getGalleryRole(slide) !== 'variant-hero') return;
        var image = slide.querySelector('img[data-smart-variant-src]');
        if (!image || image.dataset.smartVariantPrefetched === 'true') return;
        if (slide.getAttribute('data-current-variant-media') === 'true') return;

        var source = image.getAttribute('data-smart-variant-src');
        if (!source) return;

        image.dataset.smartVariantPrefetched = 'true';
        var preload = new Image();
        preload.decoding = 'async';
        preload.src = source;
        group.__smartPdpPrefetchImages.push(preload);
      });
    }

    function scheduleIdleVariantPrefetch(group) {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;

      function queuePrefetch() {
        window.setTimeout(function () {
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(function () {
              prefetchVariantHeroes(group);
            }, { timeout: 3000 });
          } else {
            prefetchVariantHeroes(group);
          }
        }, 1000);
      }

      if (document.readyState === 'complete') {
        queuePrefetch();
      } else {
        window.addEventListener('load', queuePrefetch, { once: true });
      }
    }

    function bindVariantIntentPrefetch(group) {
      var productSection = getProductSection(group);
      if (!productSection || productSection.dataset.smartVariantPrefetchBound === 'true') return;
      productSection.dataset.smartVariantPrefetchBound = 'true';

      function handleIntent(event) {
        var target = event.target && event.target.closest ? event.target.closest('[data-smart-variant-pill], [data-option-selector]') : null;
        if (target) prefetchVariantHeroes(group);
      }

      productSection.addEventListener('pointerover', handleIntent, { passive: true });
      productSection.addEventListener('focusin', handleIntent);
      productSection.addEventListener('pointerdown', handleIntent, { passive: true });
      productSection.addEventListener('touchstart', handleIntent, { passive: true });
    }

    function openVisibleLightbox(group, mediaId) {
      var enabled = window.Station && Station.Theme && Station.Theme.config && Station.Theme.config.product && Station.Theme.config.product.enableLightbox;
      var jq = window.jQuery;
      if (!enabled || !jq || !jq.fancybox) return false;

      var anchors = getThumbs(group).map(function (thumb) {
        return thumb.querySelector('a');
      }).filter(function (anchor) {
        return !!anchor;
      });
      if (!anchors.length) return false;

      var index = getIndexByMediaId(group, mediaId);
      jq.fancybox(jq(anchors), { index: index >= 0 ? index : 0 });
      return true;
    }

    function syncVariantFromLocation(group) {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (error) {
        applyVariantMediaFilter(group, { source: 'history' });
        return;
      }

      var locationVariantId = params.get('variant');
      var selectedVariant = getSelectedVariant(group);
      if (
        locationVariantId &&
        (!selectedVariant || String(selectedVariant.id) !== String(locationVariantId)) &&
        window.Station &&
        Station.Theme &&
        Station.Theme.Product &&
        typeof Station.Theme.Product.setVariantByID === 'function'
      ) {
        Station.Theme.Product.setVariantByID(parseInt(locationVariantId, 10), false);
        scheduleVariantSync(group);
        return;
      }

      applyVariantMediaFilter(group, { source: 'history' });
    }

    function bindGroup(group) {
      if (group.dataset.smartPdpGalleryController === 'true') return;
      group.dataset.smartPdpGalleryController = 'true';
      group.classList.add('smart-pdp-gallery-ready');

      var scroller = getScroller(group);
      if (!scroller) return;

      var thumbsWrap = group.querySelector('.secondary-media-types');
      if (thumbsWrap) {
        thumbsWrap.classList.add('smart-pdp-media-thumbs');
        thumbsWrap.setAttribute('data-smart-pdp-media-thumbs', '');
      }

      group.querySelectorAll('.smart-pdp-gallery-main .primary-media-container > a, .smart-pdp-gallery-main .image-container > a').forEach(function (anchor) {
        anchor.addEventListener('click', function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          var slide = anchor.closest('.primary-media-container');
          openVisibleLightbox(group, getMediaId(slide));
        }, true);
      });

      getAllThumbs(group).forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          var index = getThumbs(group).indexOf(thumb);
          if (index < 0) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          scrollToIndex(group, index, 'thumb', isMobile() ? 'auto' : 'smooth');
        }, true);
      });

      var prev = group.querySelector('[data-smart-pdp-gallery-prev]');
      var next = group.querySelector('[data-smart-pdp-gallery-next]');

      if (prev) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          if (prev.disabled) return;
          var current = group.__smartPdpCurrentIndex != null ? group.__smartPdpCurrentIndex : getNearestIndexFromScroll(group);
          scrollToIndex(group, current - 1, 'arrow', 'smooth');
        });
      }

      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          if (next.disabled) return;
          var current = group.__smartPdpCurrentIndex != null ? group.__smartPdpCurrentIndex : getNearestIndexFromScroll(group);
          scrollToIndex(group, current + 1, 'arrow', 'smooth');
        });
      }

      var scrollTimer;
      scroller.addEventListener('scroll', function () {
        if (group.__smartPdpProgrammaticScroll) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          syncFromNativeScroll(group);
        }, 90);
      }, { passive: true });

      if ('onscrollend' in window) {
        scroller.addEventListener('scrollend', function () {
          syncFromNativeScroll(group);
        }, { passive: true });
      }

      var productSection = getProductSection(group);
      productSection.querySelectorAll('[data-option-selector]').forEach(function (field) {
        field.addEventListener('change', function () {
          scheduleVariantSync(group);
        });
      });

      productSection.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (variantInput) {
        variantInput.addEventListener('change', function () {
          scheduleVariantSync(group);
        });
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          applyVariantMediaFilter(group, { source: 'resize' });
          scrollToIndex(group, group.__smartPdpCurrentIndex || getActiveIndex(group), 'resize', 'auto');
        }, 120);
      });

      window.addEventListener('pageshow', function () {
        syncVariantFromLocation(group);
      });
      window.addEventListener('popstate', function () {
        syncVariantFromLocation(group);
      });

      bindVariantIntentPrefetch(group);
      scheduleIdleVariantPrefetch(group);

      window.requestAnimationFrame(function () {
        applyVariantMediaFilter(group, { source: 'init' });
      });
    }

    groups.forEach(bindGroup);
  }

  function initTabs(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-smart-pdp-tabs]').forEach(function (tabsRoot) {
      var buttons = tabsRoot.querySelectorAll('[data-smart-pdp-tab]');
      var panels = tabsRoot.querySelectorAll('[data-smart-pdp-panel]');
      buttons.forEach(function (button) {
        if (button.dataset.smartPdpBound === 'true') return;
        button.dataset.smartPdpBound = 'true';
        button.addEventListener('click', function () {
          var target = button.getAttribute('data-smart-pdp-tab');

          buttons.forEach(function (btn) {
            btn.classList.remove('is-active');
            btn.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function (panel) {
            panel.classList.remove('is-active');
            panel.hidden = true;
          });

          button.classList.add('is-active');
          button.setAttribute('aria-selected', 'true');

          var activePanel = tabsRoot.querySelector('[data-smart-pdp-panel="' + target + '"]');
          if (activePanel) {
            activePanel.classList.add('is-active');
            activePanel.hidden = false;
          }

          if (isDesignMode()) return;

          updateSmartPdpStickyOffsets(document);
          var styles = getComputedStyle(tabsRoot);
          var stickyOffset = parseInt(styles.getPropertyValue('--smart-pdp-tabs-sticky-top'), 10) || 0;
          var scrollGap = parseInt(styles.getPropertyValue('--smart-pdp-tabs-scroll-gap'), 10) || 28;
          var rect = tabsRoot.getBoundingClientRect();
          var desiredTop = stickyOffset + scrollGap;

          if (Math.abs(rect.top - desiredTop) > 6) {
            var targetTop = window.pageYOffset + rect.top - desiredTop;
            window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
          }
        });
      });
    });
  }

  function initAccordion(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-smart-pdp-accordion-trigger]').forEach(function (trigger) {
      if (trigger.dataset.smartPdpBound === 'true') return;
      trigger.dataset.smartPdpBound = 'true';
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-smart-pdp-accordion-item]');
        var accordion = trigger.closest('[data-smart-pdp-accordion]');
        var singleOpen = accordion && accordion.getAttribute('data-single-open') === 'true';
        var beforeTop = trigger.getBoundingClientRect().top;

        if (singleOpen && accordion) {
          accordion.querySelectorAll('[data-smart-pdp-accordion-item]').forEach(function (other) {
            if (other !== item) {
              other.classList.remove('is-open');
              var otherTrigger = other.querySelector('[data-smart-pdp-accordion-trigger]');
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            }
          });
        }

        if (item) {
          item.classList.toggle('is-open');
          trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
        }

        if (!isDesignMode() && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
          window.requestAnimationFrame(function () {
            var afterTop = trigger.getBoundingClientRect().top;
            var delta = afterTop - beforeTop;
            if (Math.abs(delta) > 1) window.scrollBy({ top: delta, behavior: 'auto' });
          });
        }
      });
    });
  }



  /* Cart add / cart popup logic is handled globally by assets/smart-cart-popup.js. */

  var SMART_PDP_PURCHASE_BUTTON_SELECTOR = [
    '.smart-pdp-buy-stack .smart-pdp-add-button button',
    '.smart-pdp-buy-stack .smart-pdp-add-button .button',
    '.smart-pdp-buy-now-button',
    '.smart-pdp-add-to-cart-button',
    '.smart-sticky-add-to-cart-button',
    '.smart-sticky-add-to-cart-trigger',
    '.sticky-cart .shopify-product-form button',
    '.sticky-cart-action button'
  ].join(',');

  function getSmartPdpPurchaseButtons(activeButton) {
    var buttons = Array.prototype.slice.call(document.querySelectorAll(SMART_PDP_PURCHASE_BUTTON_SELECTOR));
    if (activeButton && buttons.indexOf(activeButton) === -1) buttons.push(activeButton);
    var seen = [];
    return buttons.filter(function (button) {
      if (!button || seen.indexOf(button) !== -1) return false;
      seen.push(button);
      return true;
    });
  }

  function setSmartPdpFormBusy(form, isBusy, activeButton) {
    if (!form) return;

    getSmartPdpPurchaseButtons(activeButton).forEach(function (button) {
      if (button.closest('.shopify-payment-button')) return;

      if (isBusy) {
        if (!Object.prototype.hasOwnProperty.call(button.dataset, 'smartPdpWasDisabled')) {
          button.dataset.smartPdpWasDisabled = button.disabled ? 'true' : 'false';
        }

        button.disabled = true;

        if (button === activeButton) {
          button.classList.add('is-smart-loading');
          button.setAttribute('aria-busy', 'true');
        } else {
          button.classList.add('is-smart-locked');
          button.removeAttribute('aria-busy');
        }
      } else {
        button.disabled = button.dataset.smartPdpWasDisabled === 'true';
        delete button.dataset.smartPdpWasDisabled;
        button.classList.remove('is-smart-loading');
        button.classList.remove('is-smart-locked');
        button.removeAttribute('aria-busy');
      }
    });
  }

  function initSmartBuyNow(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-smart-pdp-buy-now]');

    buttons.forEach(function (button) {
      if (button.dataset.smartPdpBuyNowBound === 'true') return;
      button.dataset.smartPdpBuyNowBound = 'true';

      button.addEventListener('click', function (event) {
        if (event) event.preventDefault();
        if (isDesignMode()) return;

        var form = button.closest('form[action*="/cart/add"]');
        if (!form || button.disabled) return;
        form.dataset.smartPdpBuyNowMode = 'true';

        var variantInput = form.querySelector('[name="id"]');
        if (!variantInput || !variantInput.value) return;

        var quantityInput = form.querySelector('[name="quantity"]');
        var quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;
        if (!quantity || quantity < 1) quantity = 1;

        var properties = getLineItemProperties(form);

        var items = [
          {
            id: Number(variantInput.value),
            quantity: quantity,
            properties: properties
          }
        ];

        var logoBox = document.querySelector('[data-smart-pdp-custom-logo]');
        var logoCheckbox = logoBox && logoBox.querySelector('[data-smart-pdp-custom-logo-checkbox]');

        if (logoBox && logoCheckbox && logoCheckbox.checked) {
          var propertyName = logoBox.getAttribute('data-property-name') || 'Custom Logo Service';
          var propertyValue = logoBox.getAttribute('data-property-value') || 'Yes';
          var addonVariantId = logoBox.getAttribute('data-addon-variant-id');
          var addonProductTitle = logoBox.getAttribute('data-addon-product-title') || 'Custom Logo Service';
          var addonQuantityMode = logoBox.getAttribute('data-addon-quantity-mode') || 'per_order';

          items[0].properties = items[0].properties || {};
          items[0].properties[propertyName] = propertyValue;

          if (addonVariantId) {
            items.push({
              id: Number(addonVariantId),
              quantity: addonQuantityMode === 'match_product_quantity' ? quantity : 1,
              properties: {
                'Service for': document.title || 'Photo booth product',
                'Added from': addonProductTitle
              }
            });
          }
        }

        if (window.SmartSizeUpgrade && typeof window.SmartSizeUpgrade.getSelectedAddon === 'function') {
          var sizeUpgrade = window.SmartSizeUpgrade.getSelectedAddon(form);
          if (sizeUpgrade && sizeUpgrade.addonVariantId) {
            items[0].properties = items[0].properties || {};
            items[0].properties[sizeUpgrade.mainPropertyName || 'Size Upgrade'] = sizeUpgrade.mainPropertyValue || 'Yes';

            items.push({
              id: Number(sizeUpgrade.addonVariantId),
              quantity: sizeUpgrade.quantityMode === 'per_order' ? 1 : quantity,
              properties: sizeUpgrade.addonProperties || {}
            });
          }
        }

        if (window.SmartExtendedWarranty && typeof window.SmartExtendedWarranty.getSelectedAddon === 'function') {
          var extendedWarranty = window.SmartExtendedWarranty.getSelectedAddon(form);
          if (extendedWarranty && extendedWarranty.addonVariantId) {
            items[0].properties = items[0].properties || {};
            items[0].properties[extendedWarranty.mainPropertyName || 'Extended Warranty'] = extendedWarranty.mainPropertyValue || 'Yes';

            items.push({
              id: Number(extendedWarranty.addonVariantId),
              quantity: extendedWarranty.quantityMode === 'per_order' ? 1 : quantity,
              properties: extendedWarranty.addonProperties || {}
            });
          }
        }

        setSmartPdpFormBusy(form, true, button);

        var shopRoot = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

        fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Buy now failed');
            return response.json();
          })
          .then(function () {
            return window.SmartBFCM ? window.SmartBFCM.get().then(function (cart) { return window.SmartBFCM.reconcile(cart, true); }) : null;
          })
          .then(function () {
            window.location.href = addSmartPdpPreviewQuery(shopRoot + 'checkout');
          })
          .catch(function (error) {
            if (window.console && console.warn) console.warn('[Smart PDP] Buy It Now failed:', error);
            delete form.dataset.smartPdpBuyNowMode;
            setSmartPdpFormBusy(form, false);
          });
      });
    });
  }

  function initSmartVariantPills(root) {
    var scope = root || document;
    var groups = scope.querySelectorAll('[data-smart-variant-option]');
    if (!groups.length) return;

    function setSelected(group, value) {
      group.querySelectorAll('[data-smart-variant-pill]').forEach(function (pill) {
        var active = pill.getAttribute('data-option-value') === value;
        pill.classList.toggle('is-selected', active);
        pill.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    groups.forEach(function (group) {
      var select = group.querySelector('select[data-option-selector]');
      if (!select) return;

      setSelected(group, select.value);

      group.querySelectorAll('[data-smart-variant-pill]').forEach(function (pill) {
        if (pill.dataset.smartVariantPillBound === 'true') return;
        pill.dataset.smartVariantPillBound = 'true';

        pill.addEventListener('click', function () {
          var value = pill.getAttribute('data-option-value');
          if (!value || select.value === value) {
            setSelected(group, select.value);
            return;
          }

          select.value = value;
          setSelected(group, value);
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      if (select.dataset.smartVariantPillSyncBound !== 'true') {
        select.dataset.smartVariantPillSyncBound = 'true';
        select.addEventListener('change', function () {
          setSelected(group, select.value);
        });
      }
    });
  }



  function initSmartStickyCartTiming() {
    var sticky = document.getElementById('sticky-cart');
    if (!sticky || sticky.dataset.smartStickyTimingBound === 'true') return;

    var trigger = document.querySelector('.smart-pdp-buy-stack .smart-pdp-add-row') ||
      document.querySelector('.smart-pdp-buy-stack [data-smart-pdp-add-to-cart]') ||
      document.querySelector('.smart-pdp-buy-stack');

    if (!trigger) return;

    sticky.dataset.smartStickyTimingBound = 'true';
    sticky.classList.add('smart-sticky-managed');

    function updateStickyVisibility() {
      var isMobile = !window.matchMedia || window.matchMedia('(max-width: 749px)').matches;
      if (!isMobile) {
        sticky.classList.remove('is-smart-sticky-visible');
        return;
      }

      var rect = trigger.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var threshold = viewportHeight * 0.5;
      var shouldShow = rect.bottom <= threshold;

      sticky.classList.toggle('is-smart-sticky-visible', shouldShow);
    }

    var ticking = false;
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateStickyVisibility();
      });
    }

    updateStickyVisibility();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('pageshow', requestUpdate);
  }

  function initAll(root) {
    safeRun('trust cards', function () { initTrustCards(root); });
    safeRun('custom logo', function () { initCustomLogo(root); });
    safeRun('preview links', function () { initSmartPdpPreviewLinks(root); });
    // Cart popup is handled globally by assets/smart-cart-popup.js
    safeRun('sticky tab offset', function () { initSmartPdpStickyOffset(root); });
    safeRun('media thumbnails', function () { initMediaThumbs(root); });
    safeRun('tabs', function () { initTabs(root); });
    safeRun('accordion', function () { initAccordion(root); });
    safeRun('custom buy now', function () { initSmartBuyNow(root); });
    safeRun('variant pills', function () { initSmartVariantPills(root); });
    safeRun('sticky cart timing', function () { initSmartStickyCartTiming(); });
  }


  function resetSmartPdpPurchaseState() {
    getSmartPdpPurchaseButtons().forEach(function (button) {
      if (!button) return;
      if (Object.prototype.hasOwnProperty.call(button.dataset, 'smartPdpWasDisabled')) {
        button.disabled = button.dataset.smartPdpWasDisabled === 'true';
        delete button.dataset.smartPdpWasDisabled;
      } else if (button.classList.contains('is-smart-loading') || button.classList.contains('is-smart-locked')) {
        button.disabled = button.getAttribute('aria-disabled') === 'true' || button.classList.contains('disabled');
      }
      button.classList.remove('is-smart-loading');
      button.classList.remove('is-smart-locked');
      button.removeAttribute('aria-busy');
    });

    document.querySelectorAll('form[data-smart-pdp-buy-now-mode="true"]').forEach(function (form) {
      delete form.dataset.smartPdpBuyNowMode;
    });
  }

  window.addEventListener('pageshow', resetSmartPdpPurchaseState);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resetSmartPdpPurchaseState();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    if (!isDesignMode()) return;
    document.body.classList.remove('smart-pdp-no-scroll');
    document.body.classList.remove('smart-cart-popup-open');
    document.body.style.paddingRight = '';
  });
})();
